module.exports = {
      id: "7428a903e5c45b922d137e4a9f9bc0b2state-after-reconstruction.svg-usage",
      viewBox: "0 0 417 417",
      url: __webpack_public_path__ + "sprite.svg#7428a903e5c45b922d137e4a9f9bc0b2state-after-reconstruction.svg",
      toString: function () {
        return this.url;
      }
    }